import _ from 'underscore';
import templateStr from 'text!./activity-schedule.html';
import moment from 'moment';

export default [function () {
    return {
        restrict: 'A',
        template: templateStr,

        scope: {
            activities: '=',
            showribbon: '=',
            tabTitle: '=',
            header: '='
        },
        controller: ['$filter', '$scope', 'ActivityService', 'gatewayParamConfig', function ($filter, $scope, ActivityService, gatewayParamConfig) {
            $scope.showcompleteribbon = true;
            $scope.currentDate = moment();
            $scope.tomorrow = moment().add(1, 'days');
            $scope.endOfWeek = moment().endOf('week');
            var activitiesData = 0;

            filterActivities();

            $scope.showRibbon = function () {
                return typeof $scope.showribbon === 'undefined' ? true : $scope.showribbon;
            };

            function filterActivities() {
                $scope.fullActivities = [];
                /*$scope.activitiesToday = [];
                $scope.activitiesTomorrow = [];
                $scope.activitiesThisWeek = [];
                $scope.activitiesFuture = [];
                $scope.activitiesOverdue = [];
                $scope.activitiesComplete = [];*/

                if (angular.isDefined($scope.activities) && $scope.activities.length > 0) {
                    $scope.activities = $filter('orderBy')($scope.activities, 'dueDate');
                    var filteredActivities = setActivitiesDueDateEmpty($scope.activities);
                    filteredActivities = setActivitiesOverdue(filteredActivities);
                    filteredActivities = setActivitiesToday(filteredActivities);
                    filteredActivities = setActivitiesTomorrow(filteredActivities);
                    filteredActivities = setActivitiesThisWeek(filteredActivities);
                    $scope.activitiesFuture = filteredActivities;
                    setActivitiesFuture(filteredActivities);

                    filteredActivities = setActivitiesCompleted(filteredActivities);
                }
            }

            function setActivitiesFuture(activities) {
                activities.forEach(function (activity, key) {
                    if (activity.status != 'complete') {
                        // for making completed activities come at the end of the table_MSF
                        $scope.fullActivities.push(activity);
                    }
                });
            }

            function setActivitiesDueDateEmpty(activities) {

                activities.forEach(function (activity) {
                    if (!angular.isDefined(activity.dueDate) && activity.dueDate === undefined) {
                        // $scope.activitiesOverdue.push(activity);
                        $scope.fullActivities.push(activity);
                    }
                });

                return _.difference(activities, $scope.fullActivities);
            }

            function setActivitiesCompleted(activities) {
                activities.forEach(function (activity, key) {
                    if (activity.status === 'complete') {
                        //$scope.activitiesComplete.push(activity);
                        $scope.fullActivities.push(activity);
                    }
                });

                return _.difference(activities, $scope.fullActivities);
            }

            function setActivitiesOverdue(activities) {
                activities.forEach(function (activity) {
                    if (activity.status != 'complete') {
                        if (!angular.isDefined(activity.dueDate) || $scope.currentDate.isAfter(activity.dueDate, 'day')) {
                            // $scope.activitiesOverdue.push(activity);
                            $scope.fullActivities.push(activity);
                        }
                    }
                });

                return _.difference(activities, $scope.fullActivities);
            }

            function setActivitiesToday(activities) {
                activities.forEach(function (activity) {
                    if ($scope.currentDate.isSame(activity.dueDate, 'day')) {
                        // $scope.activitiesToday.push(activity);
                        $scope.fullActivities.push(activity);
                    }
                });

                return _.difference(activities, $scope.fullActivities);
            }

            function setActivitiesTomorrow(activities) {
                activities.forEach(function (activity) {
                    if ($scope.tomorrow.isSame(activity.dueDate, 'day')) {
                        // $scope.activitiesTomorrow.push(activity);
                        $scope.fullActivities.push(activity);
                    }
                });

                return _.difference(activities, $scope.fullActivities);
            }

            function setActivitiesThisWeek(activities) {
                activities.forEach(function (activity) {
                    var dueDate = moment(activity.dueDate);
                    if (dueDate.isAfter($scope.tomorrow, 'day') && !dueDate.isAfter($scope.endOfWeek, 'day')) {
                        //$scope.activitiesThisWeek.push(activity);
                        $scope.fullActivities.push(activity);
                    }
                });

                return _.difference(activities, $scope.fullActivities);
            }
            function getActivitiesForCurrentUserAndGroups() {
                if (activitiesData == 0) {
                    activitiesData = ActivityService.getActivitiesForCurrentUserAndGroups();
                }
                return activitiesData;
            }
            function updateForActivityFilter() {

                return getActivitiesForCurrentUserAndGroups().then(function (accounts) {

                    //filterActivities();

                    if (angular.isDefined($scope.fullActivities)) {

                        $scope.allActivityData = $scope.fullActivities.slice($scope.queryOptions.offsetStartForOverdueFilter, $scope.queryOptions.offsetEndForOverdueFilter + 1);
                    } else {
                        $scope.allActivityData == [];
                        $scope.fullActivities = [];
                    }
                    return {
                        'items': $scope.allActivityData,
                        'maxNumberOfResults': $scope.fullActivities.length
                    };
                }, function () {
                    //error
                });
            }

            //Code for Activity filter -pagination_MSF
            $scope.queryOptions = {
                offsetStartForOverdueFilter: 0,
                offsetEndForOverdueFilter: $scope.pageSize - 1
            };
            var _getLoadByOffsetForActivity = _.memoize(function () {
                return function (offsetStart, offsetEnd) {
                    $scope.queryOptions.offsetStartForOverdueFilter = offsetStart;
                    $scope.queryOptions.offsetEndForOverdueFilter = offsetEnd;
                    return updateForActivityFilter();
                };
            });

            $scope.pageSize = gatewayParamConfig.activitiesResultsPerPage;

            $scope.getLoadByOffsetForActivity = function () {
                return _getLoadByOffsetForActivity();
            };

            $scope.$watchCollection('activities', function () {
                filterActivities();
                $scope.$broadcast('customFilterSelected'); //for updating paginated table data
            });
            $scope.activitiesTabTitle = $scope.tabTitle;
        }]
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gateway/directives/ActivityScheduleDirective/ActivitySchedule.js
// module id = 1724
// module chunks = 0